import { ErrorDescription } from 'ethers'
import type { ReactNode } from 'react'

const errorMessageByName: Record<string, (error: ErrorDescription) => string> = {
    Error: (error) => {
        const { args } = error
        return args.map((arg) => arg.toString()).join(', ')
    },
}

const errorMessageByCode: Record<string, (error: unknown) => string> = {
    ACTION_REJECTED: () => {
        return 'User rejected transaction'
    },
}

interface GetTransactionErrorMessageOptions {
    customErrorRendererByName?: Record<string, (error: ErrorDescription) => ReactNode>
}

export const getTransactionErrorMessage = (
    error?: ErrorDescription | unknown,
    options?: GetTransactionErrorMessageOptions,
): ReactNode => {
    if (!error) {
        return ''
    }
    if (error instanceof ErrorDescription) {
        return (
            options?.customErrorRendererByName?.[error.name](error) ||
            errorMessageByName[error.name]?.(error) ||
            error.name
        )
    }
    if (typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'string') {
        return errorMessageByCode[error.code]?.(error) || error.code
    }

    return 'An unknown error occurred'
}
